function SvgFilters() {
  return (
    <>
      <svg
        width={0}
        height={0}
        style={{ position: "absolute" }}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="svg-icon-gradient" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor="#FF9900" />
            <stop offset="100%" stopColor="#FF7100" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
}

export default SvgFilters;
